import { FC } from "react";

import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";

import { FileText, ExternalLink } from "lucide-react";

import { getOrderViewUrl } from "@/modules/order/routes";

interface ErpExpressQuoteBannerProps {
  orderId?: string;
  message?: string;
  linkText?: string;
}

const bannerStyles = `
  @keyframes bounce {
    0%, 20%, 53%, 80%, 100% {
      transform: translate3d(0, 0, 0);
    }
    40%, 43% {
      transform: translate3d(0, -8px, 0);
    }
    70% {
      transform: translate3d(0, -4px, 0);
    }
    90% {
      transform: translate3d(0, -2px, 0);
    }
  }

  @keyframes shine {
    0% {
      background-position: -200% center;
    }
    100% {
      background-position: 200% center;
    }
  }

  .quote-banner {
    animation: bounce 2s ease-in-out;
    background: linear-gradient(
      90deg,
      #dbeafe 0%,
      #dbeafe 40%,
      #ffffff 50%,
      #dbeafe 60%,
      #dbeafe 100%
    );
    background-size: 200% 100%;
    animation: bounce 2s ease-in-out, shine 3s ease-in-out infinite;
  }
`;

const ErpExpressQuoteBanner: FC<ErpExpressQuoteBannerProps> = ({
  orderId,
  message = "Un devis a été généré pour le service ERP express que vous venez de créer. Vous pouvez le consulter et le valider.",
  linkText = "Voir le devis",
}) => {
  return (
    <Alert
      variant="info"
      className="quote-banner mb-3 border-blue-200 bg-blue-50"
    >
      <style dangerouslySetInnerHTML={{ __html: bannerStyles }} />
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <FileText className="me-2 text-blue-600" size={16} />
          <span className="text-blue-600">{message}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          {orderId ? (
            <Link
              to={getOrderViewUrl(orderId, "invoice")}
              className="text-blue-600 hover:text-blue-800 p-0 h-auto font-medium text-decoration-line"
            >
              {linkText}
            </Link>
          ) : (
            <button
              className="btn btn-link p-0 text-decoration-none text-blue-600 hover:text-blue-800"
              onClick={() => console.log("No order ID available")}
            >
              {linkText}
              <ExternalLink className="ms-1" size={12} />
            </button>
          )}
        </div>
      </div>
    </Alert>
  );
};

export default ErpExpressQuoteBanner;
